import React, { useState, useRef } from "react";
import EditIcon from "../../ui/EditIcon";
import { Space, Table, Tag, Typography } from "antd";

import BedForm from "./BedForm";
import { formatToINR } from "../../../helpers/utility";
import useIsMobile from "../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../hooks/usePageFillTableScroll";

function BedTable({ data, refreshBedPage, facilityId }) {
  const [isVisible, setIsVisible] = useState(false);
  const [editListData, setEditListData] = useState(null);
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );
  const columns = [
    {
      title: "Bed No",
      dataIndex: "bed_no",
      key: "bed_no",
      sorter: (a, b) => a?.bed_no?.localeCompare(b?.bed_no),
      render: (value, record) =>
        record?.is_available ? (
          <Space>
            <Typography>{value}</Typography>
            <Tag color="green">Active</Tag>
          </Space>
        ) : (
          <Space>
            <Typography>{value}</Typography>
            <Tag color="orange">In Active</Tag>
          </Space>
        ),
    },
    {
      title: "Insurance Price (Including tax)",
      dataIndex: "insurance_price",
      key: "insurance_price",
      sorter: (a, b) => a?.insurance_price - b?.insurance_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    {
      title: "Cash Price (Including tax)",
      dataIndex: "cash_price",
      key: "cash_price",
      sorter: (a, b) => a?.cash_price - b?.cash_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    {
      title: "Room No",
      dataIndex: "room_no",
      key: "room_no",
      sorter: (a, b) => a?.room_no?.localeCompare(b?.room_no),
    },
    {
      title: "Room Type",
      dataIndex: "room_type",
      key: "room_type",
      sorter: (a, b) => a?.room_type?.localeCompare(b?.room_type),
    },
    {
      title: "Floor No",
      dataIndex: "floor_no",
      key: "floor_no",
      sorter: (a, b) => a?.floor_no?.localeCompare(b?.floor_no),
    },
    {
      title: "Building Name",
      dataIndex: "building_name",
      key: "building_name",
      sorter: (a, b) => a?.building_name?.localeCompare(b?.building_name),
    },
    {
      title: "Action",
      render: (record) => (
        <EditIcon
          onClick={() => {
            setIsVisible(true);
            setEditListData(record);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <div ref={tableWrapRef} className="ui-table-fill-body">
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          scroll={tableScroll}
        />
      </div>
      {isVisible && (
        <BedForm
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          refreshBedPage={refreshBedPage}
          editListData={editListData}
          facilityId={facilityId}
        />
      )}
    </>
  );
}

export default BedTable;
